import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { i18n } from 'config/locales';

import { ErrorList } from 'components/ErrorList';
import SectionNavigation from 'components/Section/shared/SectionNavigation';

import Intro from 'components/Section/Financial/Intro';
import Bankruptcies from 'components/Section/Financial/Bankruptcy';
import Gambling from 'components/Section/Financial/Gambling';
import Taxes from 'components/Section/Financial/Taxes';
import Card from 'components/Section/Financial/Card';
import Credit from 'components/Section/Financial/Credit';
import Delinquent from 'components/Section/Financial/Delinquent';
import Nonpayment from 'components/Section/Financial/Nonpayment';
import Review from 'components/Section/Financial/Review';
import { rootSelectors } from '@redux/modules/selectors';
import { formTypes } from 'config/formTypes';
import SectionNotFound from '../shared/SectionNotFound';
import FederalDebt from './FederalDebt';
import Alimony from './Alimony';
import ChildSupport from './ChildSupport';
import CivilJudgement from './CivilJudgement';
import AssetSeized from './AssetSeized';
import Lien from './Lien';
import Foreclosure from './Foreclosure';
import Eviction from './Eviction';
import NonpaymentNonfederal from './NonpaymentNonFederal';
import Repossession from './Repossession';

const Financial = function (props) {
  const { subsection, location, isReview } = props;

  const subsectionClasses = classnames('view', `view-${subsection.name}`);

  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div className="section-view">
      {title && <h1 className="title">{title}</h1>}
      {para}

      <div className={subsectionClasses}>
        {isReview && (
          <div className="top-btns">
            <ErrorList />
          </div>
        )}

        <Switch>
          <Route path="/form/financial/intro" component={Intro} />
          <Route path="/form/financial/bankruptcy" component={Bankruptcies} />
          <Route path="/form/financial/alimony" component={Alimony} />
          <Route path="/form/financial/childsupport" component={ChildSupport} />
          <Route path="/form/financial/civiljudgement" component={CivilJudgement} />
          <Route path="/form/financial/assetseized" component={AssetSeized} />
          <Route path="/form/financial/lien" component={Lien} />
          <Route path="/form/financial/foreclosure" component={Foreclosure} />
          <Route path="/form/financial/eviction" component={Eviction} />
          <Route path="/form/financial/nonpaymentnonfederal" component={NonpaymentNonfederal} />
          <Route path="/form/financial/repossession" component={Repossession} />
          <Route path="/form/financial/gambling" component={Gambling} />
          <Route path="/form/financial/taxes" component={Taxes} />
          <Route path="/form/financial/federaldebt" component={FederalDebt} />
          <Route path="/form/financial/card" component={Card} />
          <Route path="/form/financial/credit" component={Credit} />
          <Route path="/form/financial/delinquent" component={Delinquent} />
          <Route path="/form/financial/nonpayment" component={Nonpayment} />
          <Route path="/form/financial/review" component={Review} />
          <Route component={SectionNotFound} />
        </Switch>

        <SectionNavigation currentPath={location.pathname} />
      </div>
    </div>
  );
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  subsection: state.section.subsection,
  isReview: rootSelectors.section.getIsSectionInReview(state),
  formType: rootSelectors.application.getFormType(state),
});

Financial.propTypes = {
  subsection: PropTypes.object,
  location: PropTypes.object,
  isReview: PropTypes.bool,
};

Financial.defaultProps = {
  subsection: {},
  location: {},
};

export default connect(mapStateToProps)(Financial);

export var FinancialSections = function () {
  return <Review />;
};
